import Accordion from '@/common/components/Accordion';
import Alert from '@/common/components/Alert';
import { formatCurrency, formatPercentage } from '@/common/utils/formatters';
import { CompanyData } from '@/features/companies/types/companies.type';
import { UpdateFinancialModal } from '@/features/privateCompanies/pages/Update/components/UpdateFinancialModal';
import { AlertCircleIcon, Building2Icon, CircleChevronDownIcon, DollarSignIcon, GripVerticalIcon, SquareCheckIcon, SquareIcon } from 'lucide-react';
import { billIntegrationProcess } from '../constants/billIntegrationProcess.constant';

const FinancialSection = ({ company, defaultOpen = true }: { company?: CompanyData; defaultOpen?: boolean }) => {
  const sortedSpecialEntries = [...(company?.fee_rule?.special_entries || [])].sort(
    (a, b) => a?.execution_priority - b?.execution_priority,
  )

  return (
    <Accordion
      defaultOpen={defaultOpen}
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateFinancialModal company={company} />
          </div>

          <p className='text-xl'>
            Financeiro
          </p>
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={(
        <div className='flex flex-col gap-4'>
          <div className='flex items-center gap-2'>
            <p>
              Enviar fatura para processamento:
            </p>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />

              <p>
                {company?.bill_integration_process ? billIntegrationProcess[company.bill_integration_process] : '--'}
              </p>
            </div>
          </div>

          <div className='flex flex-col gap-2'>
            <p>
              Tarifas especiais:
            </p>

            <Alert variant="warning" Icon={AlertCircleIcon} containerClassName="bg-transparent p-0">
              <div className="flex flex-col">
                <p className="text-sm">
                  Defina a ordem da aplicação, a mais acima será a tarifa qual será aplicada primeiro.
                </p>

                <p className="text-xs italic font-light">
                  Caso a próxima também se aplique ao posto, e esteja configurada para não aplicar quando houver uma
                  outra especial, ela não será aplicada.
                </p>
              </div>
            </Alert>

            <div className='flex flex-col gap-3'>
              {sortedSpecialEntries.length > 0 ? sortedSpecialEntries.map((specialFee, i) => (
                <div key={`fee_template_${i}`} className='flex items-center gap-4'>
                  <div className='flex items-center gap-2'>
                    <GripVerticalIcon strokeWidth={1.5} className='text-white-400' />

                    <div>
                      <p>
                        {specialFee.execution_priority}
                      </p>
                    </div>
                  </div>

                  <div className='flex items-center gap-2'>
                    <Building2Icon strokeWidth={1.5} className='text-white-400' />

                    <div>
                      <p className='italic text-xs font-light'>
                        Estabelecimento
                      </p>

                      <p>
                        {specialFee.target?.general_information?.fantasy_name || 'Todos'}
                      </p>
                    </div>
                  </div>

                  <div className='flex items-center gap-2'>
                    <CircleChevronDownIcon strokeWidth={1.5} className='text-white-400' />

                    <div>
                      <p className='italic text-xs font-light'>
                        Tarifa
                      </p>

                      <p>
                        {specialFee.fee_template.display_name}
                      </p>
                    </div>
                  </div>

                  <div className='flex items-center gap-2'>
                    <DollarSignIcon strokeWidth={1.5} className='text-white-400' />

                    <div>
                      <p className='italic text-xs font-light'>
                        Valor
                      </p>

                      <p className='text-nowrap'>
                        {specialFee.fee_template.calculate_as === 'percentage'
                          ? formatPercentage(Number(specialFee.value))
                          : formatCurrency(Number(specialFee.value))}
                      </p>
                    </div>
                  </div>

                  <div className='flex items-center gap-2'>
                      {!!specialFee.not_use_if_has_special_fee ? (
                        <SquareCheckIcon strokeWidth={1.5} className="text-white-400" />
                      ) : (
                        <SquareIcon strokeWidth={1.5} className="text-white-400" />
                      )}

                    <div>
                      <p className='italic text-xs font-light'>
                        Ignorar se houver uma tarifa acima já aplicada
                      </p>

                      <p>
                        {!!specialFee.not_use_if_has_special_fee ? 'Sim' : 'Não'}
                      </p>
                    </div>
                  </div>
                </div>
              )) : (
                <p className='italic font-light'>
                  Não possui
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default FinancialSection;
